<template>
  <section class="honor-container">

    <!-- Title -->
    <header class="honor-header">
      <h2 class="title-serif">Court of Honor</h2>
      <div class="title-line"></div>
    </header>

    <!-- PAGE BOYS & GIRLS -->
    <section class="honor-section"><br>
      <h3 class="section-title">Page Boys & Girls</h3><br>
      <div class="honor-grid">
        <div
          v-for="(n, i) in pajecitos"
          :key="'paje-'+i"
          :ref="el => setPajeRef(el, i)"
          class="honor-item"
        >
          <span class="honor-chip">{{ n }}</span>
        </div>
      </div>
    </section>

    <!-- CHAMBERLAIN OF HONOR -->
    <section class="honor-hero"><br>
      <div class="hero-label">Chamberlain of Honor</div><br>
      <p class="hero-name">Andrew Balderrama</p><br>
    </section>

    <!-- MY DAMDS / BRIDESMAIDS -->
    <section class="honor-section"><br>
      <h3 class="section-title">My Bridesmaids</h3><br>
      <div class="honor-grid">
        <div
          v-for="(n, i) in damas"
          :key="'dama-'+i"
          :ref="el => setDamaRef(el, i)"
          class="honor-item"
        >
          <span class="honor-chip">{{ n }}</span>
        </div>
      </div>
    </section>

    <!-- MY GROOMSMEN / CHAMBERLAINS -->
    <section class="honor-section">
      <h3 class="section-title">My Chamberlains</h3>
      <div class="honor-grid">
        <div
          v-for="(n, i) in chambelanes"
          :key="'cham-'+i"
          :ref="el => setChamRef(el, i)"
          class="honor-item"
        >
          <span class="honor-chip">{{ n }}</span>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CuadroDeHonor',
  setup() {

    const pajecitos = [
      'Estella Lopez Castillo',
      'Nicholas Medina'
    ]

    const damas = [
      'Chayada Poomchareon',
      'Ariana Carrillo',
      'Samantha Galang',
      'Samantha Rodríguez',
      'Angelik Genao',
      'Audrey Martinez',
      'Scarlet Valencia'
    ]

    const chambelanes = [
      'Julio Lopez Castillo',
      'Julian Sicairos',
      'Mathew Ahmed',
      'Joseph Torres',
      'Kellen Hodges',
      'D’Angelo Bañuelos',
      'Kiko Yambao'
    ]

    const pajeRefs = ref([])
    const damaRefs = ref([])
    const chamRefs = ref([])

    const setPajeRef = (el, i) => pajeRefs.value[i] = el
    const setDamaRef = (el, i) => damaRefs.value[i] = el
    const setChamRef = (el, i) => chamRefs.value[i] = el

    const createObserver = (elements, baseDelay = 0.05) => {

      const io = new IntersectionObserver(entries => {

        entries.forEach(entry => {
          if (!entry.isIntersecting) return

          const idx = elements.indexOf(entry.target)

          gsap.fromTo(
            entry.target,
            { y: 40, opacity: 0, scale: 0.95 },
            {
              y: 0,
              opacity: 1,
              scale: 1,
              duration: 0.6,
              delay: idx * baseDelay,
              ease: 'power3.out'
            }
          )

          io.unobserve(entry.target)
        })

      }, { threshold: 0.25 })

      elements.forEach(el => el && io.observe(el))
    }

    onMounted(async () => {
      await nextTick()
      createObserver(pajeRefs.value)
      createObserver(damaRefs.value)
      createObserver(chamRefs.value)
    })

    return {
      pajecitos,
      damas,
      chambelanes,
      setPajeRef,
      setDamaRef,
      setChamRef
    }
  }
}
</script>



<style scoped>
/* Contenedor general – rosa elegante como tus secciones previas */
.honor-container{
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 42px 18px 56px;
  background: #f0c9d3;
  background-image:
    linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,0)),
    radial-gradient(1000px 400px at 50% -10%, rgba(255,255,255,.32), rgba(255,255,255,0) 60%),
    linear-gradient(180deg, #f5b9c9, #f5b9c9);
  border-radius: 18px;
  box-shadow: 0 10px 28px rgba(0,0,0,.08);
}

/* Header */
.honor-header{ text-align:center; margin-bottom: 18px; }
.title-serif{
  font-family: 'quote', serif;
  font-size: 36px;
  color: #fff;
  line-height: 1.05;
  margin: 0 0 8px;
}
.title-line{
  width: 64px; height: 2px; margin: 0 auto;
  background: #fff; opacity: .85; border-radius: 2px;
}

/* Chambelán de honor – tarjeta destacada */
.honor-hero{
  text-align: center;
  border-radius: 16px;
  padding: 18px 16px;
  margin: 18px auto 24px;
  max-width: 680px;
}
.hero-label{
  font-family: 'britishgruesa', serif;
  font-size: 44px;
  color: #ffffff;
  font-weight: 400;
}
.hero-name{
  font-family: 'quote', cursive;
  font-size: 24px;
  color: #ffffff;
  margin: 0;
}

/* Secciones */
.honor-section{ margin-top: 18px; }
.section-title{
  text-align: center;
  font-family: 'britishgruesa', serif;
  font-weight: 400;
  letter-spacing: .16em;
  font-size: 48px;
  color: #ffffff;
  margin: 10px 0 12px;
}

/* Grid de nombres */
.honor-grid{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}
.honor-item{
  opacity: 0; /* se anima a 1 con GSAP */
}
.honor-chip{
  display: block;
  width: 100%;
  padding: 12px 14px;
  color: #ffffff;
  border-radius: 14px;
  font-family: 'quote', serif;
  font-size: 24px !important;
  text-align: center;
}

/* Hover sutil en desktop */
@media (hover:hover){
  .honor-chip:hover{
    transform: translateY(-1px);
    transition: transform .18s ease, box-shadow .18s ease;
    box-shadow: 0 10px 18px rgba(0,0,0,.12), inset 0 1px 0 rgba(255,255,255,.75);
  }
}

/* Responsive fino */
@media (max-width: 420px){
  .title-serif{ font-size: 40px; }
  .hero-name{ font-size: 28px; }
  .honor-chip{ font-size: 15px; padding: 11px 12px; }
}
</style>